import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcBack32Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { FAB } from '@gem/ui-kit';

import { useAllPinsHeaderPresenter } from 'APP/main/ChatView/AllPins/AllPinsHeader/AllPinsHeader.presenter';

import styles from './AllPinsHeader.styles.m.css';

interface IAllPinsHeaderProps {
  groupId: string;
}

export const AllPinsHeader: FC<IAllPinsHeaderProps> = observer(({ groupId }) => {
  const { t } = useTranslation();
  const presenter = useAllPinsHeaderPresenter(groupId);

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <FAB
          className={styles.back}
          Icon={IcBack32Icon}
          onClick={presenter.onBack}
          size="30"
          theme="8"
        />
        <div className={styles.headerTitle}>{t('multiple_pin_header', { 0: presenter.count })}</div>
      </div>
    </div>
  );
});
